import React, {FunctionComponent, useRef} from "react";
import {useDispatch, useSelector} from "react-redux";
import {ValidatorForm} from "react-material-ui-form-validator";
import {Step} from "../../../WizardMap";
import {removeCurrentDisposal} from "../../../state/disposalSlice";
import WizardStep from "../../WizardStep";
import statusContact from "../../../../images/Progress/kontakt_icn.svg";
import {Box, FormControl, InputLabel, makeStyles, NativeSelect} from "@material-ui/core";
import {longInputWith} from "./StepContactData";
import {RootState} from "../../../../redux/rootReducer";
import CommonTextInput from "../../../../commonComponents/ValidateTextInput";
import {setName, setLastName, setStreet, setPostalCode, setCity, setCountry} from "../../../state/contactSlice";
import {NavigationProps} from "../../../slideRouter/navigationHook";
import {selectOptions} from "./SelectOptions";

const useStyles = makeStyles(() => ({
    formContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: 30
    },
    shortTextInput: {
        width: (longInputWith / 2) - 10
    },
    longTextInput: {
        width: longInputWith,
        marginBottom: 20
    },
    longWithContainer: {
        width: longInputWith,
        display: "flex",
        justifyContent: "space-between",
        marginBottom: 20
    }
}));

const StepContactDataMobile1: FunctionComponent<NavigationProps> = ({gotoPrevSlide, gotoNextSlide}) => {

    const classes = useStyles();
    const dispatch = useDispatch();
    const formRef = useRef<ValidatorForm | null>(null);
    const {address} = useSelector((state: RootState) => state.contact);

    const handleFormSubmit = (): void => {
        if (formRef.current) {
            formRef.current.isFormValid(false).then(isValid => {
                isValid && gotoNextSlide(Step.CONTACT_INFO_MOBILE_2);
            });
        }
    };

    const handleBackClicked = (): void => {
        dispatch(removeCurrentDisposal());
        gotoPrevSlide();
    };

    return (
        <WizardStep
            title={"Bitte geben Sie Ihre Kontaktdaten an"}
            icon={statusContact}
            backButton
            onBackClick={handleBackClicked}
            nextButton
            onNextClick={handleFormSubmit}
        >
            <ValidatorForm
                ref={formRef}
                onSubmit={() => {
                }}
                className={classes.formContainer}
                instantValidate={false}
            >
                <CommonTextInput
                    name="firstName"
                    label="Vorname"
                    validators={["required"]}
                    errorMessages={["erforderlich"]}
                    value={address.name}
                    onChangeText={(text: string) => dispatch(setName(text))}
                    className={classes.longTextInput}
                />
                <CommonTextInput
                    name="lastName"
                    label="Nachname"
                    validators={["required"]}
                    errorMessages={["erforderlich"]}
                    value={address.lastName}
                    onChangeText={(text: string) => dispatch(setLastName(text))}
                    className={classes.longTextInput}
                />
                <CommonTextInput
                    name={"streetAndNumber"}
                    label={"Straße & Hausnummer"}
                    validators={["required"]}
                    errorMessages={["erforderlich"]}
                    value={address.street}
                    onChangeText={(text: string) => dispatch(setStreet(text))}
                    className={classes.longTextInput}
                />
                <Box className={classes.longWithContainer}>
                    <CommonTextInput
                        name={"zipCode"}
                        label={"PLZ"}
                        validators={["required", "isNumber"]}
                        errorMessages={["erforderlich", "ungültig"]}
                        value={address.postalCode}
                        onChangeText={(val: string) => dispatch(setPostalCode(val))}
                        className={classes.shortTextInput}
                    />
                    <CommonTextInput
                        name={"city"}
                        label={"Stadt"}
                        validators={["required"]}
                        errorMessages={["erforderlich"]}
                        value={address.city}
                        onChangeText={(text: string) => dispatch(setCity(text))}
                        className={classes.shortTextInput}
                    />
                </Box>
                <FormControl style={{width: longInputWith}}>
                    <InputLabel htmlFor="country" style={{color: "#999"}}>Land</InputLabel>
                    <NativeSelect
                        value={address.country}
                        style={{color: "#000"}}
                        inputProps={{
                            name: "country",
                            id: "country"
                        }}
                        onChange={({target}) => {
                            dispatch(setCountry(target.value));
                        }}
                    >
                        {selectOptions.country}
                    </NativeSelect>
                </FormControl>
            </ValidatorForm>
        </WizardStep>
    );
};

export default StepContactDataMobile1;
